import * as R from 'ramda'

export const updatedValue = (value) =>
  R.when(R.equals(value), R.always(undefined))

export const pruneValues = R.reject(R.isNil)

export const MAX_DESCRIPTION_TEXT_LENGTH = 400
export const MAX_ADDRESS_TEXT_LENGTH = 191
